// extracted by mini-css-extract-plugin
module.exports = {"col":"TasteEditor_col__2WIhm","delete":"TasteEditor_delete__1SAV6"};